// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";

import { Colors } from "../../../assets/Colors";
import {
  fetchGet,
  fetchPost,
  fetchPut,
  fetchPostMultipartSeaweed,
} from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableSimple } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import { isRequired, useForm } from "../../../components/isRequired";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import "react-toastify/dist/ReactToastify.css";
import { BiArrowBack } from "react-icons/bi";
import { useLocation, useNavigate, useParams } from "react-router-dom";

// Ekstrak nama file asli dari format "UUID-namafile.ext"
const extractFileName = (fileString) => {
  if (!fileString) return "";
  if (fileString.includes("-")) {
    const parts = fileString.split("-");
    return parts.slice(1).join("-");
  }
  return fileString;
};

// Icon sederhana berdasarkan ekstensi file
const getFileIcon = (fileName) => {
  if (!fileName) return "📎";
  const ext = fileName.split(".").pop().toLowerCase();
  if (["pdf"].includes(ext)) return "📄";
  if (["jpg", "jpeg", "png", "gif"].includes(ext)) return "🖼️";
  if (["doc", "docx"].includes(ext)) return "📝";
  return "📎";
};

// Buka / download lampiran dari file server
const getDataFromURL = (url) => {
  if (!url || url.trim() === "") {
    alert("Tidak ada file attachment");
    return;
  }

  const encodedUrl = encodeURIComponent(url);
  const fileUrl = process.env.REACT_APP_API_UPLOAD_URL
    ? `${process.env.REACT_APP_API_UPLOAD_URL}file/${encodedUrl}`
    : `http://192.168.212.24:5000/v1/files/${encodedUrl}`;

  fetch(fileUrl, {
    method: "GET",
    headers: { Accept: "application/octet-stream" },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.blob();
    })
    .then((blob) => {
      const fileBlobUrl = window.URL.createObjectURL(blob);
      if (blob.type.includes("pdf") || blob.type.includes("image")) {
        window.open(fileBlobUrl, "_blank");
      } else {
        const link = document.createElement("a");
        link.href = fileBlobUrl;
        let downloadName = url;
        if (url.includes("-") && url.split("-")[0].length === 36) {
          const uuidParts = url.split("-");
          downloadName = uuidParts.slice(1).join("-").replace(/_/g, " ");
        }
        link.download = downloadName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(fileBlobUrl), 100);
      }
    })
    .catch((err) => {
      console.error("Error loading file:", err);
      alert("Gagal membuka file. File mungkin belum diupload ke server.");
    });
};

const InsertPettyCashPage = ({}) => {
  const params = useParams();

  let initialState = {
    BisnisUnitID: params.BisnisUnit,
    JenisCashJournal: "Kas",
    JenisTransaksi: "Pengeluaran",
    Status: "-1",
    Tanggal: new Date(),
  };

  let initialStateModal = {
    SDTDate: new Date(),
  };
  const validations = [
    ({ UserPCName }) =>
      isRequired(UserPCName) || { UserPCName: "Nama UserPC wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Status wajib diisi" },
    ({ KelompokID }) =>
      isRequired(KelompokID) || { KelompokID: "Kelompok wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Kelompok wajib diisi" },
    ({ DetailAccountID }) =>
      isRequired(DetailAccountID) || {
        DetailAccountID: "Detail Account wajib diisi",
      },
    ({ Status }) =>
      isRequired(Status) || { Status: "Detail Account wajib diisi" },
  ];

  const {
    changed,
    values,
    isValid,
    touched,
    submitHandler,
    customHandler,
    changeHandler,
    errors,
    blastChange,
  } = useForm(initialState, validations);

  const barang = useMutation((formData) => fetchGet("Master/Barang/min"));
  const [buttonTouched, setButtonTouched] = useState(false);
  const [detail, setDetail] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [modalDetail, setModalDetail] = useState(initialStateModal);
  const [modalID, setModalID] = useState(0);
  const ModalOpener = (detail) => {
    setShowModal(true);
  };
  const param = useLocation();

  const mutation = useMutation((formData) =>
    fetchPost("Master/UserPC", formData),
  );
  const mutationAdd = useMutation((formData) =>
    fetchPost("Accounting/CashJournal", formData),
  );
  const mutationGet = useMutation((formData) =>
    fetchGet("Accounting/CashJournal/" + formData),
  );
  const mutationUpdate = useMutation((formData) =>
    fetchPut("Accounting/CashJournal", formData),
  );
  const mutationApproval = useMutation((formData) =>
    fetchPost("Accounting/CashJournal/kirim", formData),
  );
  const detailAccount = useMutation((formData) =>
    fetchGet("GetMinMasterDetailAccountV2"),
  );
  const mutationFile = useMutation((formData) =>
    fetchPostMultipartSeaweed(formData),
  );

  const ModalEdit = (detail, id) => {
    setModalID(id);
    setModalDetail(detail);
    setShowModal(true);
    setShowModalEdit(true);
  };

  const ModalDelete = (id) => {
    let newDetail = [...detail];
    newDetail.splice(id, 1);
    let totals = 0;
    newDetail.map(({ Nominal }, id) => {
      totals += parseFloat(Nominal);
    });
    customHandler(totals, "Nominal");
    setDetail(newDetail);
  };

  const navigate = useNavigate();

  useEffect(() => {
    detailAccount.mutate();

    barang.mutate();
    if (params.transid) {
      mutationGet.mutate(params.transid.toString().replaceAll("-", "/"));
    }
  }, []);

  useEffect(() => {
    if (mutationUpdate) {
      if (mutationUpdate.isSuccess) {
        navigate("/finance/pettycash/" + params.BisnisUnit);
      }
    }
  }, [mutationUpdate.status]);

  useEffect(() => {
    if (mutationAdd) {
      if (mutationAdd.isSuccess) {
        navigate("/finance/pettycash/" + params.BisnisUnit);
      }
    }
  }, [mutationAdd.status]);
  useEffect(() => {
    if (mutationApproval) {
      if (mutationApproval.isSuccess) {
        navigate("/finance/pettycash/" + params.BisnisUnit);
      }
    }
  }, [mutationApproval.status]);
  useEffect(() => {
    if (mutationGet.data) {
      setDetail(mutationGet.data.data[0].Data);
      let tempData = mutationGet.data.data[0];

      blastChange(tempData);
    }
  }, [mutationGet.status]);

  const header = [
    { name: "Account", key: "Account", modifiers: "Account" },
    { name: "Account Name", key: "Account", modifiers: "AccountName" },
    { name: "Keterangan", key: "Keterangan", modifiers: "Keterangan" },
    { name: "Nominal", key: "Nominal", modifiers: "Numbers" },
    { name: "tools", key: "EditDelete", modifiers: "EditDelete" },
  ];

  const modalHandler = (value, names) => {
    const newValues = { ...modalDetail, [names]: value };
    setModalDetail(newValues);
  };

  const modalHandlerText = (event) => {
    const newValues = {
      ...modalDetail,
      [event.target.name]: event.target.value,
    };
    setModalDetail(newValues);
  };
  // NumberFormat (react-number-format) memanggil onValueChange dengan objek
  // {formattedValue, value, floatValue} — bukan event DOM — sehingga tampilan
  // boleh berpemisah-ribuan sementara nilai yang disimpan tetap angka murni
  // (pola sama dgn SaldoAwal.js).
  const modalHandlerNominal = (values) => {
    const newValues = { ...modalDetail, Nominal: values.floatValue?.toString() || "" };
    setModalDetail(newValues);
  };
  const inputBuilder = [
    {
      type: "DetailAccount",
      name: "Account",
      title: "Account",
      handler: modalHandler,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "text",
      name: "Keterangan",
      title: "Keterangan",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "numberFormatSatu",
      name: "Nominal",
      title: "Nominal",
      handler: modalHandlerNominal,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
  ];

  const Kirim = () => {
    let newValues = values;
    console.log(newValues["Nominal"]);
    try {
      newValues["Tanggal"] = newValues["Tanggal"].toISOString();
      newValues["Nominal"] = newValues["Nominal"].toString();
    } catch (err) {}
    newValues["Type"] = "pettycash";

    // Upload lampiran bila ada file baru yang dipilih (objek File),
    // lalu simpan nama file ber-UUID ke field "File".
    if (newValues["File"] && typeof newValues["File"] === "object") {
      try {
        const { v4: uuidv4 } = require("uuid");
        const nama =
          uuidv4() + "-" + newValues["File"].name.replaceAll(" ", "_");
        const fd = new FormData();
        fd.append("file", newValues["File"], nama);
        mutationFile.mutate(fd);
        newValues["File"] = nama;
      } catch (error) {
        console.log(error);
      }
    }

    newValues["Data"] = detail;
    if (params.transid) {
      newValues["Status"] = "1";
      mutationUpdate.mutate(newValues);
    } else {
      mutationAdd.mutate(newValues);
    }
  };

  const Approve = () => {
    let newValues = values;
    mutationApproval.mutate(newValues);
  };

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col  mt-5">
                <div className="flex w-full justify-end flex-col sm:flex-row ">
                  <button
                    onClick={() => navigate("/finance")}
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    <BiArrowBack className="text-xl text-gray-800 pr-2" />
                    Kembali
                  </button>
                  {!params.approval ? (
                    <button
                      onClick={() => Kirim()}
                      className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                    >
                      {mutationAdd.isLoading ? (
                        <>
                          <svg
                            aria-hidden="true"
                            role="status"
                            className="inline mr-3 w-4 h-4 text-white animate-spin"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="#E5E7EB"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="current
                                       Color"
                            />
                          </svg>
                          Loading
                        </>
                      ) : (
                        "Simpan"
                      )}
                    </button>
                  ) : (
                    <button
                      onClick={() => Approve()}
                      className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                    >
                      {mutationAdd.isLoading ? (
                        <>
                          <svg
                            aria-hidden="true"
                            role="status"
                            className="inline mr-3 w-4 h-4 text-white animate-spin"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="#E5E7EB"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="current
                                       Color"
                            />
                          </svg>
                          Loading
                        </>
                      ) : (
                        "Kirim"
                      )}
                    </button>
                  )}
                </div>

                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"text"}
                    value={values}
                    name={"JenisTransaksi"}
                    title={"Jenis Transaksi"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"text"}
                    value={values}
                    name={"DariKepada"}
                    title={"Dibayar kepada"}
                    onChange={changeHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={false}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"Bagianv3"}
                    value={values}
                    name={"BagianID"}
                    title={"Bagian"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={false}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"DetailPembayaran"}
                    value={values}
                    name={"DetailCashJournal"}
                    title={"Detail Pembayaran"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={false}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"dateOnly"}
                    value={values}
                    name={"Tanggal"}
                    title={"Tanggal"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={false}
                  />
                </div>
                <div className="w-1/2">
                  <HrdInputGenerator
                    type={"text"}
                    value={values}
                    name={"Keterangan"}
                    title={"Keterangan"}
                    onChange={changeHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={false}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"numberFormatSatu"}
                    value={values}
                    name={"Nominal"}
                    title={"Nominal"}
                    onChange={changeHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                {/* LAMPIRAN / DATA PENDUKUNG */}
                <div className="w-1/2">
                  <HrdInputGenerator
                    type={"file"}
                    value={values}
                    name={"File"}
                    title={"Lampiran (Data Pendukung)"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={false}
                    errors={errors}
                    disabled={false}
                  />
                </div>

                {/* Preview lampiran lama saat edit (field masih berupa string) */}
                {values.File &&
                  typeof values.File === "string" &&
                  values.File.trim() !== "" && (
                    <div className="w-1/2 px-3 mb-4">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                        Lampiran Tersimpan
                        <span className="text-blue-600 text-xs ml-2">
                          ✓ File tersedia
                        </span>
                      </label>
                      <div className="flex items-center space-x-2">
                        <button
                          type="button"
                          onClick={() => getDataFromURL(values.File)}
                          className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 border border-blue-600 rounded shadow-sm"
                        >
                          Lihat File
                        </button>
                      </div>
                      <div className="mt-2 p-2 bg-gray-50 rounded border">
                        <div className="flex items-center">
                          <span className="text-lg mr-2">
                            {getFileIcon(extractFileName(values.File))}
                          </span>
                          <span className="text-sm text-gray-700 truncate">
                            {extractFileName(values.File)}
                          </span>
                        </div>
                        {values.File.includes("-") && (
                          <p className="text-xs text-gray-500 mt-1">
                            UUID: {values.File.split("-")[0]}
                          </p>
                        )}
                      </div>
                    </div>
                  )}

                <hr />
                <DynamicTableSimple
                  data={detail}
                  header={header}
                  Master={true}
                  OnClick={ModalOpener}
                  name={"Purchase Requisition"}
                  barang={barang.data}
                  edit={ModalEdit}
                  delete={ModalDelete}
                  account={detailAccount.data}
                />
              </div>
            </Card>
            <Modal
              size="lg"
              active={showModal}
              toggler={() => {
                setShowModal(true);
              }}
            >
              <ModalHeader
                className="mt-20"
                toggler={() => {
                  setShowModal(false);
                  setShowModalEdit(false);
                }}
              >
                {showModalEdit ? "Edit Data" : "Tambah Data"}
              </ModalHeader>
              <ModalBody>
                <form className="w-full " onSubmit={submitHandler}>
                  {inputBuilder.map(
                    (
                      {
                        type,
                        name,
                        title,
                        handler,
                        modifiers,
                        size,
                        required,
                        disabled,
                        edit,
                      },
                      id,
                    ) => {
                      if (!edit || showModalEdit) {
                        return (
                          <HrdInputGenerator
                            type={type}
                            value={modalDetail}
                            name={name}
                            title={title}
                            onChange={handler}
                            touched={touched}
                            buttonTouched={buttonTouched}
                            modifiers={modifiers}
                            size={size}
                            required={required}
                            errors={errors}
                            disabled={disabled}
                          />
                        );
                      }
                    },
                  )}
                </form>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="red"
                  buttonType="link"
                  onClick={() => {
                    setShowModal(false);
                    setShowModalEdit(false);
                  }}
                  ripple="dark"
                >
                  Cancel
                </Button>

                <Button
                  color={isValid || !isValid ? "green" : "blueGray"}
                  disabled={mutation.isLoading}
                  onClick={() => {
                    if (!isValid && changed) {
                      setButtonTouched(true);
                    }
                    let tempIsValid = isValid;
                    if (!isValid) {
                    }
                    if (showModalEdit) {
                      let newValues = [...detail];
                      newValues[modalID] = modalDetail;
                      let totals = 0;
                      newValues.map(({ Nominal }, id) => {
                        totals += parseFloat(Nominal);
                      });
                      customHandler(totals, "Nominal");
                      setDetail(newValues);
                      setModalDetail(initialStateModal);
                      setShowModal(false);
                      setShowModalEdit(false);
                    } else {
                      const newValues = [...detail, modalDetail];
                      let totals = 0;
                      newValues.map(({ Nominal }, id) => {
                        totals += parseFloat(Nominal);
                      });
                      customHandler(totals, "Nominal");

                      setDetail(newValues);
                      setModalDetail(initialStateModal);
                      setShowModal(false);
                    }
                  }}
                  ripple={isValid ? "light" : ""}
                >
                  {showModalEdit ? "Ubah" : "Tambah"}
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsertPettyCashPage;
